__turbopack_context__.v({
  "blocksBackgroundColor": "ShopWidget-module-scss-module__v-HjsG__blocksBackgroundColor",
  "blocksFontColor": "ShopWidget-module-scss-module__v-HjsG__blocksFontColor",
  "eventsWidget": "ShopWidget-module-scss-module__v-HjsG__eventsWidget",
  "header": "ShopWidget-module-scss-module__v-HjsG__header",
  "link": "ShopWidget-module-scss-module__v-HjsG__link",
  "loadingArrayClassName": "ShopWidget-module-scss-module__v-HjsG__loadingArrayClassName",
  "loadingClassName": "ShopWidget-module-scss-module__v-HjsG__loadingClassName",
  "secondaryNavBackgroundColor": "ShopWidget-module-scss-module__v-HjsG__secondaryNavBackgroundColor",
  "shopWidgetContainer": "ShopWidget-module-scss-module__v-HjsG__shopWidgetContainer",
  "themeBackgroundColor": "ShopWidget-module-scss-module__v-HjsG__themeBackgroundColor",
  "themeFontColor": "ShopWidget-module-scss-module__v-HjsG__themeFontColor",
  "themeFontFamily": "ShopWidget-module-scss-module__v-HjsG__themeFontFamily",
  "upcomingNews": "ShopWidget-module-scss-module__v-HjsG__upcomingNews",
  "widget": "ShopWidget-module-scss-module__v-HjsG__widget",
});
